<template>
  <div class="container">
    <w-navbar
      :icon="'iconchevron-left'"
      nav_title="我的简历"
      @mobileLeftBtn="close">
      <div slot="rightContent">
        <span class="iconfont iconplus2" style="font-size: 20px; font-weight: 600" @click="addCv" />
      </div>
    </w-navbar>
    <div class="cv-container">
      <div class="title-container" v-if="hasOnlineCv && onlineCvDatas.length > 0">
        <span class="cv-title">推荐中的简历</span>
        <div class="more" @click="setOnlineCv" v-if="updateShow">更换简历</div>
        <div v-else />
      </div>
      <div class="no-online-cv" @click="setOnlineCv" v-else-if="cnCvsData.length">
        <div class="tips">
          <p>将简历推荐给 HR</p>
          <p>更易获得高质量 offer</p>
        </div>
        <div class="set-btn">立即推荐</div>
      </div>
      <div class="online-cv" v-if="hasOnlineCv && onlineCvDatas.length > 0">
        <cv-item-card :cvData="cvInfo" :degree="degree" :uniSchool="uniSchool" :onlineCvTime="updateTime" :showTip="false" @goEditor="goEditor" v-if="hasOnlineCv" />
      </div>
      <div class="title-container other-container" v-if="hasOnlineCv && onlineCvDatas.length > 0">
        <span class="cv-title">其他简历</span>
        <div class="more" style="opacity: 0">更换简历</div>
      </div>
      <div class="other-cvs" v-for="(item, index) in cvList" :key="index">
        <cv-item-card @goEditor="goEditor" @cvOperation="cvOperation" :cvData="item" />
      </div>
    </div>
  </div>
</template>

<script>
import WNavbar from "@/components/global/w-navbar";
import CvItemCard from '../cvItemCard'
import moment from 'moment'
import {mapState} from "vuex";
export default {
  name: "CvsRecommend",
  props: {
    onlineCvToken: {
      type: String,
      default: ""
    },
    onlineCvTime: {
      type: String,
      default: ""
    }
  },
  components: {
    WNavbar,
    CvItemCard
  },
  watch: {

  },
  computed: {
    ...mapState('cv', [ 'onlineCvData', 'onlineVisibility', 'onlineCvValid' ]),
    ...mapState('cvIndex', [ 'cvList' ]),
    // recommendCv() {
    //   if (this.hasOnlineCv) {
    //     return this.cvList.filter(cv => cv.token === this.onlineCvToken)[0]
    //   } else {
    //     return ''
    //   }
    // },
    // otherCv() {
      // if (this.onlineCvToken) {
      //   return this.cvList.filter(cv => cv.token !== this.onlineCvToken)
      // } else if (!this.onlineCvToken) {
      //   return this.cvList
      // }
    // },
    onlineCvDatas() {
      return this.cvList.filter(cv => cv.token === this.onlineCvToken)
    },
    // 是否有在线简历
    hasOnlineCv () {
      console.log(this.onlineCvData)
      if (this.onlineCvData && Object.keys(this.onlineCvData).length && !this.onlineVisibility) {
        return !!Object.keys(this.onlineCvData).length
      } else {
        return 0
      }
    },
    // 在线简历数据
    cvInfo () {
      if (this.hasOnlineCv) {
        return this.onlineCvData.resume?.info
      }
    },
    // 在线简历更新时间
    updateTime () {
      if (this.hasOnlineCv) return `${ this.onlineCvData.updated_at || this.onlineCvData.resume.updated_at }`
    },
    // 中文非导师简历列表
    cnCvsData () {
      return this.cvList.filter(item => item.lang === 'cn' && !item.is_mentor && item.can_editable)
    },
    // 是否显示更新按钮
    updateShow () {
      let onlineCvTime = this.hasOnlineCv ? moment(this.onlineCvData.resume.updated_at).format('YYYYMMDDHHmmss') : this.onlineCvData.updated_at && moment(this.onlineCvData.updated_at).format('YYYYMMDDHHmmss')

      for (let i = 0; i < this.cnCvsData.length; i++) {
        let cvTime = moment(this.cnCvsData[i].update_time).format('YYYYMMDDHHmmss')
        if (cvTime > onlineCvTime) return true
      }
    },
    // 在线简历教育学校
    uniSchool () {
      if (this.cvInfo?.education_experiences.length) {
        return this.cvInfo.education_experiences[0].cust_uni_name || this.cvInfo.education_experiences[0].school.cn
      }
    },
    // 在线简历学历
    degree () {
      if (this.cvInfo?.education_experiences.length) {
        return this.cvInfo.education_experiences[0].cust_degree || this.cvInfo.education_experiences[0].degree_name.cn
      }
    }
  },
  data() {
    return {

    }
  },
  mounted () {

  },
  methods: {
    close() {
      this.$emit('closeCvRecommend');
    },
    goEditor(obj) {
      this.$emit('goEditor', obj)
    },
    setOnlineCv() {
      this.$emit('setOnlineCv')
    },
    addCv() {
      this.$emit('addCv')
    },
    cvOperation(cvData) {
      this.$emit('operation', cvData)
    }
  }
}
</script>

<style lang="scss" scoped>
.cv-container {
  width: 100%;
  height: 100%;
  padding: 12px 24px 24px;
  overflow: auto;
}
.container {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  padding: 43px 0 12px;
  .title-container {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cv-title {
      color: #404040;
      font-size: 18px;
      font-weight: 500;
    }
    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 76px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #ececec;
      font-size: 13px;
      color: #606060;
    }
  }
  .other-container {
    margin-top: 32px;
  }
  .other-cvs {
    margin-top: 12px;
  }
  .no-online-cv {
    width: 100%;
    height: 88px;
    border-radius: 6px;
    background: url("https://files.wondercv.com/m/cvs/no-online-cv.jpg") no-repeat;
    background-size: 100% 100%;
    margin-bottom: 24px;
    padding: 0 14px 0 71px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tips {
      color: #606060;
      font-size: 14px;
      line-height: 20px;
    }
    .set-btn {
      width: 80px;
      height: 28px;
      border-radius: 14px;
      background-color: #ff6644;
      color: #fff;
      text-align: center;
      line-height: 28px;
      font-size: 14px;
    }
  }
}
</style>